module.exports = {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }